import { PolicyMapping } from '@summit/core';
import { DisplaySchema, ObjectSchema } from '../display-schema';
import { DisplayType } from '../display-type.enum';
import { SummitIdObject } from '../summit-id-object';
import { ViewConfig } from './view-config';
import { ViewType } from './view-info';
import { ViewModel } from './view-model';

export class ViewModelSchema extends DisplaySchema<ViewConfig<SummitIdObject>> {
  readonly refTitle = 'View Configuration';
  //override readonly refServerAPI = 'TenantCredentials';
  override readonly refServerObjectName = 'ViewModel';
  readonly refColumnList: ObjectSchema<ViewConfig<SummitIdObject>> = {
    id: { propertyName: 'id', formField: true },
    name: {
      propertyName: 'name',
      formField: true,
      columnField: true,
      displayName: 'Name',
      validationMessages: [{ type: 'required', message: 'Name is required' }]
    },
    policy: {
      propertyName: 'policy',
      formField: true,
      columnField: true,
      displayName: 'Policy',
      displayType: DisplayType.Enum,
      displayTypeParameter: PolicyMapping
    },
    type: {
      propertyName: 'type',
      formField: true,
      columnField: true,
      displayName: 'Type',
      displayType: DisplayType.Enum,
      displayTypeParameter: ViewType
    },
    tableName: {
      propertyName: 'tableName',
      formField: true,
      columnField: true,
      displayName: 'Table Name'
    },
    dateBar: {
      propertyName: 'dateBar',
      formField: true,
      columnField: true,
      displayName: 'Date Bar'
      //displayType: DisplayType.Enum,
      //displayTypeParameter: ['none', 'weekRange', 'weekRangeWithNum', 'month', 'day', 'monthRange', 'week']
    },
    dateBarLabel: {
      propertyName: 'dateBarLabel',
      formField: true,
      columnField: true,
      displayName: 'Date Bar Label'
    },
    viewColumns: {
      propertyName: 'viewColumns',
      formField: true,
      columnField: true,
      displayName: 'View Columns'
    },
    columnOrder: {
      propertyName: 'columnOrder',
      formField: true,
      columnField: true,
      displayName: 'Column Order'
    },
    groupBy: {
      propertyName: 'groupBy',
      formField: true,
      columnField: true,
      displayName: 'Group By'
    },
    groupByShiftToColumns: {
      propertyName: 'groupByShiftToColumns',
      formField: true,
      columnField: true,
      displayName: 'Group By Shift To Columns'
    },
    pinnedColumns: {
      propertyName: 'pinnedColumns',
      formField: true,
      columnField: true,
      displayName: 'Pinned Columns'
    },
    viewBy: {
      propertyName: 'viewBy',
      formField: true,
      columnField: true,
      displayName: 'View By'
    },
    filterString: {
      propertyName: 'filterString',
      formField: true,
      columnField: true,
      displayName: 'Filter String'
    },
    filterColumns: {
      propertyName: 'filterColumns',
      formField: true,
      columnField: true,
      displayName: 'Filter Columns'
    },
    filterParameters: {
      propertyName: 'filterParameters',
      formField: true,
      columnField: true,
      displayName: 'Filter Parameters'
    },
    sortParameters: {
      propertyName: 'sortParameters',
      formField: true,
      columnField: true,
      displayName: 'Sort Parameters'
    },
    showNewButton: {
      propertyName: 'showNewButton',
      formField: true,
      columnField: true,
      displayName: 'Show New Button'
    },
    showFooter: {
      propertyName: 'showFooter',
      formField: true,
      columnField: true,
      displayName: 'Show Footer'
    },
    showGroupFooters: {
      propertyName: 'showGroupFooters',
      formField: true,
      columnField: true,
      displayName: 'Show Group Footers'
    },
    showGroupFooterOfOne: {
      propertyName: 'showGroupFooterOfOne',
      formField: true,
      columnField: true,
      displayName: 'Show Group Footer Of One'
    },
    groupFooterRows: {
      propertyName: 'groupFooterRows',
      formField: true,
      columnField: true,
      displayName: 'Group Footer Rows'
    },
    urlAsView: {
      propertyName: 'urlAsView',
      formField: true,
      columnField: true,
      displayName: 'Url As View'
    },
    dragEnabled: {
      propertyName: 'dragEnabled',
      formField: true,
      columnField: true,
      displayName: 'Drag Enabled'
    },
    selectable: {
      propertyName: 'selectable',
      formField: true,
      columnField: true,
      displayName: 'Selectable'
    },
    rowMultiSelectWithClick: {
      propertyName: 'rowMultiSelectWithClick',
      formField: true,
      columnField: true,
      displayName: 'Row Multi Select With Click'
    },
    lockColumns: {
      propertyName: 'lockColumns',
      formField: true,
      columnField: true,
      displayName: 'Lock Columns'
    },
    suppressColumnMenus: {
      propertyName: 'suppressColumnMenus',
      formField: true,
      columnField: true,
      displayName: 'Suppress Column Menus'
    },
    sideBar: {
      propertyName: 'sideBar',
      formField: true,
      columnField: true,
      displayName: 'Side Bar'
    }
  };

  readonly refViewModels: ViewConfig<ViewConfig<SummitIdObject>>[] = [
    {
      id: '_tenant',
      name: 'Service Credentials',
      type: ViewType.Standard,
      viewColumns: ['name', 'enabled', 'comment'],
      columnOrder: ['name', 'enabled', 'comment'],
      sortParameters: { id: 'name', start: 'asc' },
      groupBy: ['service']
    }
  ];

  NewObject(jsonData: Partial<ViewModel<SummitIdObject>>): ViewConfig<SummitIdObject> {
    return new ViewConfig<SummitIdObject>(jsonData);
  }
}
